/* eslint-disable require-jsdoc */
// Calculate the height of the document
function getDocumentHeight() {
  const body = document.body;
  const html = document.documentElement;
  return Math.max(
      body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight,
  );
}

// Send height to parent if in an iframe
function sendHeightToParent() {
  if (window.parent !== window) {
    const height = getDocumentHeight();
    window.parent.postMessage(
        {type: 'iframeHeight', height: height},
        '*',
    );
  }
}

// Debounce utility function
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func(...args);
    }, wait);
  };
}

/**
 * This function sets up sending messages if window is in an iframe
 */
export function setupIframeMessenger() {
  // If the page is inside an iframe, send its height to the parent
  if (window.parent !== window) {
    window.addEventListener('DOMContentLoaded', sendHeightToParent);
    // Optionally, listen for DOM changes or resizes
    window.addEventListener('resize', debounce(sendHeightToParent, 300));
  }
}


export function setupIframeSizer(selector = 'frame-parent') {
  // If the page contains iframes, listen for messages from them
  const pixelThreshold = 30;
  window.addEventListener('message', function(event) {
    if (event.data && event.data.type === 'iframeHeight') {
      const iframe = document.querySelector(`${ selector } iframe`);
      if (iframe) {
        const currentHeight = iframe.offsetHeight;
        const newHeight = parseInt(event.data.height, 10);
        if (Math.abs(currentHeight - newHeight) > pixelThreshold) {
          iframe.style.height = newHeight + 'px';
        }
      }
    }
  });
}

// export default setupIframeSizer;
